import React, { FC } from "react";
import { ChatServerListItem, getItemUrl } from "../../xapp/ChatServerMessage";
import { ChatImage } from "../ChatImage";

export interface ActionItemImageProps {
    readonly className: string;
    readonly item: ChatServerListItem;
    readonly emptyImageVisible: boolean;
}

export const ActionItemImage: FC<ActionItemImageProps> = props => {

    const { item } = props;

    const singleButton = item.buttons?.length === 1;

    const itemUrl = getItemUrl(item);

    if (item.imageUrl) {
        const imageActionUrl = !singleButton ? item.imageActionUrl : null;
        return (
            <div className={props.className}>
                <ChatImage imageUrl={item.imageUrl} imageActionUrl={!itemUrl && imageActionUrl} />
            </div>);
    } else if (props.emptyImageVisible) {
        return (
            <div className={props.className}></div>
        );
    }
    return <></>;
};
